import { useQuery } from '@tanstack/react-query';
import pluralize from 'pluralize';

import { getDashboardFormSubmissionsQueryOptions, getDashboardOnboardingQueryOptions } from '@/queries/dashboard';
import { useUserStore } from '@/stores/user.store';

import trucks from '../../legacy/images/dashboard/trucks.svg';
import { GettingStartedPage } from './getting-started';
import { InspectionTrend } from './inspection-trend';
import { InspectionsToday } from './inspections-today';
import { IssuesByAssets } from './issues-assets';
import { IssueSummary } from './issues-summary';
import { MaintenanceOverview } from './maintenance-overview';
import { RecentIssues } from './recent-issues';
import { ServiceTable } from './service-table';

export const DashboardPage = () => {
  const { user } = useUserStore();
  const { data: onboarding } = useQuery(getDashboardOnboardingQueryOptions());
  const { data: formSubmissions } = useQuery(getDashboardFormSubmissionsQueryOptions());
  const dashboard = onboarding?.data ?? null;
  const formCount = formSubmissions?.count ?? null;

  return (
    <section className="flex flex-col gap-4 p-6">
      <section className="relative rounded-lg bg-gradient-to-r from-[#0085e8] to-[#c1daf4] p-8">
        <img src={trucks} alt="Dashboard banner" className="absolute top-0 right-0 h-full rounded-lg object-cover" />
        <div className="relative z-10">
          <h1 className="mb-2 text-3xl font-bold text-white">Welcome {user?.firstName}</h1>
          {formCount ? (
            <p className="text-white">
              Your workspace created{' '}
              <strong className="font-semibold">
                {formCount} {pluralize('form', formCount)}
              </strong>{' '}
              in the last 30 days!
            </p>
          ) : (
            <></>
          )}
        </div>
      </section>

      {dashboard !== null ? (
        <GettingStartedPage dashboard={dashboard} />
      ) : (
        <div className="flex flex-col gap-4">
          <div className="rounded-lg bg-white p-0 shadow-sm">
            <div className="flex">
              <div className="min-w-0 flex-1 px-6 pt-6 md:flex-[2] lg:flex-[3]">
                <InspectionTrend />
              </div>
              <div className="w-full min-w-0 border-l p-6 md:w-1/3 lg:w-1/4">
                <InspectionsToday />
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-white p-0 shadow-sm">
            <div className="flex">
              <div className="min-w-0 flex-1 p-6 md:flex-[2] lg:flex-[3]">
                <ServiceTable />
              </div>
              <div className="w-full min-w-0 border-l p-6 md:w-1/3 lg:w-1/4">
                <MaintenanceOverview />
              </div>
            </div>
          </div>

          <div className="rounded-lg bg-white p-0 shadow-sm">
            <div className="flex h-93">
              <div className="min-w-0 flex-1 p-6 md:flex-[2] lg:flex-[2]">
                <RecentIssues />
              </div>
              <div className="min-w-0 flex-1 border-l p-6 md:flex-[2] lg:flex-[2]">
                <IssuesByAssets />
              </div>
              <div className="w-full min-w-0 border-l p-6 md:w-1/3 lg:w-1/4">
                <IssueSummary />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};
